export default function isAdmin ({ next, store }) {
  const isAdmin = store.state.auth.user.roles.find(item => item.guard_name === 'admin')
  if (!isAdmin) {
    return next({
      name: 'dashboard'
    })
  }
  return next()
}
